/*
 * @Author: bianbinbin
 * @Date: 2026-01-14 19:15:53
 * @LastEditors: bianbinbin
 * @LastEditTime: 2026-03-18 14:05:43
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/router/module/switchVconsole.js
 */
const switchVconsole = r => require.ensure([], () => r(require('@/views/switchVconsole/switchVconsole.vue'), 'switchVconsole'))

const router = [
  {
    path: '/switchVconsole',
    name: 'switchVconsole',
    meta: {
      title: '开关控制台'
    },
    component: switchVconsole
  }
]

export default router
